import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { ControlLabel, FormGroup, HelpBlock } from 'react-bootstrap'
import { Typeahead } from 'react-bootstrap-typeahead'

import { getModal$ } from 'syft-acp-core/store/modals/selectors'
import { Modal } from 'syft-acp-core/components/Modal'
import { showModal, hideModal } from 'syft-acp-core/store/modals/actions'
import { toLocationOptions, toWordPrefixPatterns } from 'syft-acp-util/locationSearch'

class EmployerAccountsNewLocationModal extends PureComponent {
  static propTypes = {
    employerLocations: PropTypes.array.isRequired,
    newLocationCallback: PropTypes.func.isRequired,
    item: PropTypes.object.isRequired,
    dispatch: PropTypes.func.isRequired,
  }

  constructor(props) {
    super(props)
    this.initialState = { msg: null, valid: true, chosenLocation: '', selected: [] }
    this.state = this.initialState
    this.locationOptions = { source: null, options: [] }
    this.filterPatterns = { text: null, patterns: [] }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    // If we are becoming visible, while not being visible, reset the form.
    if (this.props.item.isShown !== nextProps.item.isShown && nextProps.item.isShown === true) {
      this.setState(this.initialState)
    }
  }

  onConfirmHandler = () => {
    if (this.validate()) {
      this.props.newLocationCallback(Number(this.state.chosenLocation))
      this.closeModal()
    }
  }

  setWeekValue = ev => {
    this.setState({ weekValue: ev.target.value })
  }

  validate = () => {
    if (!this.state.chosenLocation) {
      this.setState({ valid: false, msg: 'Select a location' })

      return false
    }

    this.setState({ valid: true, msg: null })

    return true
  }

  closeModal = () => this.props.dispatch(hideModal(this.props.item.modalName))

  openModal = () => this.props.dispatch(showModal(this.props.item.modalName))

  setLocation = selected => {
    this.setState({ selected, chosenLocation: selected.length ? selected[0].id : '', valid: true, msg: null })
  }

  // Large employers have thousands of locations, so only re-sort when the list itself changes.
  getLocationOptions = () => {
    const { employerLocations } = this.props
    if (this.locationOptions.source !== employerLocations) {
      this.locationOptions = { source: employerLocations, options: toLocationOptions(employerLocations) }
    }

    return this.locationOptions.options
  }

  filterLocation = (option, { text }) => {
    if (this.filterPatterns.text !== text) {
      this.filterPatterns = { text, patterns: toWordPrefixPatterns(text) }
    }

    return this.filterPatterns.patterns.every(pattern => pattern.test(option.searchText))
  }

  render() {
    return (
      <Modal
        header="Add new location to employer account"
        isShown={this.props.item.isShown}
        onClose={this.closeModal}
        onConfirm={this.onConfirmHandler}
        confirmationText="Add location"
      >
        <div className="employer-email-invoices-modal">
          <FormGroup className="form-item" validationState={this.state.valid ? null : 'error'}>
            <ControlLabel htmlFor="employer-accounts-new-location-input">Location</ControlLabel>
            <Typeahead
              id="employer-accounts-new-location"
              inputProps={{
                id: 'employer-accounts-new-location-input',
                name: 'location',
                autoComplete: 'off',
                'aria-invalid': !this.state.valid,
                'aria-describedby': this.state.valid ? undefined : 'employer-accounts-new-location-error',
              }}
              labelKey="label"
              options={this.getLocationOptions()}
              filterBy={this.filterLocation}
              selected={this.state.selected}
              onChange={this.setLocation}
              placeholder="Search or choose a location"
              emptyLabel="No matches."
              clearButton
              positionFixed
              flip
            />
            {!this.state.valid && (
              <HelpBlock id="employer-accounts-new-location-error">{this.state.msg}</HelpBlock>
            )}
          </FormGroup>
        </div>
      </Modal>
    )
  }
}

export default connect(state => ({
  item: getModal$(state.modals)('employerAccountsNewLocationModal'),
}))(EmployerAccountsNewLocationModal)
